import { render, staticRenderFns } from "./PurchaseOrderDetailsModal.vue?vue&type=template&id=758bb415&scoped=true"
import script from "./PurchaseOrderDetailsModal.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderDetailsModal.vue?vue&type=style&index=0&id=758bb415&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758bb415",
  null
  
)

export default component.exports